var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page-layout',[_c('span',{staticClass:"display-1 d-block text-primary"},[_vm._v("429")]),_c('div',{staticClass:"mb-4 lead"},[_vm._v(_vm._s(_vm.$t("error-pages.body-429")))]),_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t("error-pages.footer-link"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }